import script from "./CertificateItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CertificateItem.vue?vue&type=script&setup=true&lang=js"

import "./CertificateItem.vue?vue&type=style&index=0&id=288333da&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-288333da"]])

export default __exports__